<template>
  <div>
    <!-- 头部 -->
    <back :title="titlename"></back>
    <!--  -->
    <div class="newsinfo">
      <p class="title">{{newscontent.TITLE}}</p>
      <p class="time">{{newscontent.RECORDTIME}}</p>
      <div id="content" class="content" v-html="newscontent.CONTENT">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
      data() {
        return {
           titlename:"元和街道第一窗口",
           id:"",
           newscontent:""
        };
      },
      created:function(){
        this.id=this.$route.query.newsid
      },
      updated:function(){
        let obj = document.getElementById('content')
        let imgs = obj.getElementsByTagName('img')
        for(let i =0; i < imgs.length; i++){
          imgs[i].style.width = '100%'
        }
      },
      methods:{
        // 获取详情
        getnewslist(){
          this.$http.post(this.$store.state.host+"/interface/getNews",{NEWS_ID:this.id},{emulateJSON:true})
          .then(res=>{
            //发送成功
            console.log(res)
            if(res.body.code==0){
              this.newscontent=res.body.newsPd
            }

            //if()
          },res=>{
             //发送失败
          })
        },
      },
      mounted:function(){
        this.getnewslist()
      }
    };
</script>

<style lang="less" scoped>
.newsinfo{
  font-size: .3rem;
  padding: .4rem;
  line-height: 200%;
  .title{
    font-size: .36rem;
    font-weight: bold;
  }
  .time{
    font-size: .24rem;
  }
  .content{
    // text-indent: .6rem;

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/newsinfo.vue